<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <div class="d-flex">
            <h1 class="mb-3">{{ $t('orders.bulk_order_no', {n: bulkOrderId}) }}</h1>
            <v-spacer/>
            <v-btn
                v-if="!hideEditButton"
                color="primary"
                @click="onEdit"
                :disabled="!canEditBulkOrder"
                class="mr-1"
            >
                <v-icon left>mdi-pencil</v-icon>
                {{ $t('bulk_orders.edit') }}
            </v-btn>
            <v-btn
                v-if="!hideApproveButton"
                color="warning"
                @click="onApprove"
                :loading="isBusyApprove"
                :disabled="!canApproveBulkOrder"
            >
                <v-icon left>mdi-check-decagram-outline</v-icon>
                {{ $t('bulk_orders.approve') }}
            </v-btn>
        </div>
        <bulk-order-detail v-if="bulkOrder" :bulk-order="bulkOrder"/>
        <v-skeleton-loader v-else type="card"/>
    </layout-authenticated>
</template>
<script>
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";
import SnackbarMixin from "@/mixins/SnackbarMixin";
import {API} from "@/api/api";
import BulkOrderDetail from "@/components/user/bulkOrder/BulkOrderDetail";

export default {
    name: "BulkOrder",
    mixins: [SnackbarMixin],
    components: {BulkOrderDetail, LayoutAuthenticated},
    data: () => ({
        // loading
        isBusyBulkOrder: false,
        isBusyApprove: false,
        // bulk order
        bulkOrder: null
    }),
    computed: {
        bulkOrderId() {
            return this.$route.params.bulkOrderId;
        },
        breadcrumb() {
            return [
                {
                    text: this.$t('app.name'),
                    href: '/'
                },
                {
                    text: this.$t('orders.orders_and_bulk_orders'),
                    href: '/orders'
                },
                {
                    text: this.$t("orders.bulk_order_no", {n: this.bulkOrderId}),
                    href: '/bulk-orders/' + this.bulkOrderId,
                    disabled: true
                }
            ];
        },
        isApprover() {
            let roles = this.$store.getters['identity/getRoles'];
            return roles && roles.includes('ROLE_APPROVER');
        },
        hideApproveButton() {
            return !this.isApprover;
        },
        hideEditButton() {
            return !this.isApprover;
        },
        canApproveBulkOrder() {
            return this.isApprover
                && this.bulkOrder?.state === 'WAITING_FOR_APPROVAL'
                && this.bulkOrder.orders.every(order => order.external_id === null
                    && ['active', 'cancelled'].includes(order.reservation_status));
        },
        canEditBulkOrder() {
            return this.isApprover
                && this.bulkOrder?.state === 'WAITING_FOR_APPROVAL'
                && !this.bulkOrder.orders.some(order => ['pending', 'cancel_pending'].includes(order.reservation_status));
        }
    },
    methods: {
        fetchBulkOrder() {
            this.isBusyBulkOrder = true;
            API.get("/api/bulk-orders/" + this.bulkOrderId)
                .then(response => {
                    this.bulkOrder = response.data;
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyBulkOrder = false;
                });
        },
        onApprove() {
            this.isBusyApprove = true;
            setTimeout(() => {
                API.post("/api/bulk-orders/" + this.bulkOrder.id + "/approve")
                    .then(() => {
                        this.snackbarSuccess(this.$t('snackbar.bulk_order_approved_successfully'));
                        this.$router.push({name: "approval"});
                    })
                    .catch(error => {
                        this.snackbarError(error);
                    })
                    .finally(() => {
                        this.isBusyApprove = false;
                    });
            }, 3000);
        },
        onEdit() {
            this.$router.push({name: "edit-bulk-order", params: {"bulkOrderId": this.bulkOrder.id}})
        },
    },
    created() {
        this.fetchBulkOrder();
    }
}
</script>
